const showDirectionOptions = (directions: any, translations: any, t: any) => {
  const directionsMapped: any = [];
  directions.map((x: any) =>
    directionsMapped.push({
      value: x,
      label: `${t(`${translations.common}:${x}`)}`,
    })
  );
  return directionsMapped;
};
export default showDirectionOptions;
